import { render, staticRenderFns } from "./AddTeamSocialMedia.vue?vue&type=template&id=586d9536&scoped=true&"
import script from "./AddTeamSocialMedia.vue?vue&type=script&lang=js&"
export * from "./AddTeamSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d9536",
  null
  
)

export default component.exports